import ParkPassAPI from "../parkpassAxiosConfig";

export const getAdminVehicles = async (page = 1, pageSize = 25, includeHidden = false) => {
  try {
    const response = await ParkPassAPI.get("/v1/vehicles/admin", {
      params: {
        page,
        page_size: pageSize,
        include_hidden: includeHidden,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
